export const joinDomain = (href: string) => {
  const domain = process.env.NEXT_PUBLIC_DOMAIN

  if (href.startsWith('/') && domain) {
    return `${domain}${href}`
  }
  return href
}

export const isInSite = (url?: string) => {
  if (!url) {
    return false
  }
  try {
    if (url.startsWith('/')) {
      return true
    }
    const parsedUrl = new URL(url)
    return parsedUrl.origin === process.env.NEXT_PUBLIC_DOMAIN
  } catch {
    return false
  }
}
